export default "__VITE_ASSET__dQ9XpNFe__"